<div class="ion-page" id="main-content" style="{{offlinehint}}">
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button class="head_1_1" (click)="back()" style="margin-right:10px;">
          <ion-icon style="color: white;" name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-buttons slot="end">
        <ion-button class="head_1_1" (click)="toListPage()">
          <ion-icon style="opacity: 0;" name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>

      <ion-title class="ion-text-center" (click)="toMain()"><img class="logo-small" src="assets/logo/pt-logo-small.png"/></ion-title>
    </ion-toolbar>
  </ion-header>


  <ion-content>

    <div class="cb90er" *ngIf="page_start===true">
      {{ 'devicelistpage.createnewdevice' | translate }}<br/>
    </div>

    <div class="cb90er">
      <br/>
      <img src="assets/device_blue.png" *ngIf="page_start===true"><br/>

      <span *ngIf="page_start===true">

        {{ 'devicelistpage.nodevices_title' | translate }}<br/>
        <br/>
        <div class="fontgrey_label">
          {{ 'devicelistpage.nodevices_description' | translate }}<br/>
          <br/>
          {{ 'devicelistpage.nodevices_hint' | translate }}<br/>
          <br/>
        </div>
        <br/>
      </span>

      <div *ngIf="page_scan===true">
        <h1 class="devicelist_section_title">{{ 'devicelistpage.yourDevices' | translate }}</h1>
        <table class="devicelist_table" style="table-layout: auto;">
          <tr>
            <td class="devicelist_table_header">{{ 'devicelistpage.devicenumber' | translate }}</td>
            <td class="devicelist_table_header">{{ 'assigned' | translate }}</td>
            <td class="devicelist_table_header">{{ 'wifi' | translate }}</td>
            <td class="devicelist_table_header">{{ 'setup' | translate }}</td>
            <td class="devicelist_table_header">{{ 'devicepage.unregisterAction' | translate }}</td>
          </tr>

          <tr>
            <td colspan="4">&nbsp;</td>
          </tr>

          <tr class="row_devicerow" *ngFor="let device of registeredDevices">

            <td class="devicelist_table_cell">
              {{ device.id }}
            </td>

            <td class="devicelist_table_cell">
              <ion-icon *ngIf="device.installedIn!==undefined" src="assets/ICONS/car2.svg" color="success"></ion-icon>
            </td>

            <td class="devicelist_table_cell">
              <div style="text-align: center;">
                <ion-icon *ngIf="device.wifi?.lastWifi!=='-'" name="wifi-outline" color="success"></ion-icon>
              </div>
            </td>
            <td class="devicelist_table_cell" (click)="toEditDevice(device, datapackage)">
              <ion-icon class="setupDeviceButtonSmall" name="chevron-forward-outline"></ion-icon>
            </td>
            <td class="devicelist_table_cell">
              <ion-icon class="setupDeviceButtonSmall danger" name="close"
                        (click)="toUnregisterDevice(device, datapackage)"></ion-icon>
            </td>
          </tr>
        </table>
      </div>

      <br/>
      <hr/>
      <br/>


      <div *ngIf="page_scan===true">
        <h1 class="devicelist_section_title">{{ 'devicelistpage.devicesInViscinity' | translate }}</h1>
        <table>
          <tr>
            <td class="devicelist_table_header">{{ 'devicelistpage.devicenumber' | translate }}</td>
            <td class="devicelist_table_header">{{ 'registered' | translate }}</td>
            <td class="devicelist_table_header">{{ 'wifi' | translate }}</td>
            <td class="devicelist_table_header">{{ 'setup' | translate }}</td>
          </tr>

          <tr>
            <td colspan="5">&nbsp;</td>
          </tr>

          <tr class="row_devicerow" *ngFor="let device of devices">

            <td class="devicelist_table_cell">
              {{ device.id }}
            </td>

            <td class="devicelist_table_cell">
              <ion-icon *ngIf="device.registeredTo!==''" src="assets/ICONS/add-list.svg" color="success"></ion-icon>
            </td>

            <td class="devicelist_table_cell">
              <div style="text-align: center;">
                <ion-icon *ngIf="device.wifi!==null" name="wifi-outline" color="success"></ion-icon>
              </div>
            </td>
            <td class="devicelist_table_cell">
              <ion-icon class="setupDeviceButtonSmall" name="chevron-forward-outline"
                        (click)="toEditDevice(device, datapackage)"></ion-icon>
            </td>

          </tr>
        </table>
      </div>


    </div>

  </ion-content>


  <ion-content *ngIf="false" style="color: white; font-size: 14px; ">

    <ion-header>
      <ion-toolbar>
        <ion-title class="head_1_1">11111</ion-title>
      </ion-toolbar>
    </ion-header>

    <div class="cb90er">
      <img *ngIf="page_start===true" src="assets/device_blue.png"><br/>
      <br/>
      <div *ngIf="page_start===true" style="color: white; font-size: 14px; ">

        <span *ngIf="registeredDevices!==undefined && registeredDevices.length===0">

          {{ 'devicelistpage.nodevices_title' | translate }}<br/>
          <br/>
          <div class="fontgrey_label">
            {{ 'devicelistpage.nodevices_description' | translate }}<br/>
            <br/>
            {{ 'devicelistpage.nodevices_hint' | translate }}<br/>
            <br/>
          </div>
        </span>

        <!--span *ngIf="registereddevices.length > 0">

          <ion-list>
            <ion-item *ngFor="let dev of registereddevices">
              <table>
                <tr (click)="toEditDevice(dev)">
                  <td width="50px">
                    <ion-icon *ngIf="deviceConnected(dev)" name="bluetooth-outline" color="success"></ion-icon>
                    <ion-icon *ngIf="!deviceConnected(dev)" name="bluetooth-outline"></ion-icon>
                  </td>
                  <td width="350px" class="row_1_1">
                    {{dev.label}}
                  </td>

                  <td width="100px">
                    <div style="text-align: center;">
                      <ion-icon *ngIf="dev.wifi!==''" name="wifi-outline" color="success"></ion-icon>
                    </div>
                  </td>
                  <td width="50px">
                    <a (click)="toEditDevice(dev)"><ion-icon name="chevron-forward-outline"></ion-icon></a>
                  </td>
                </tr>
              </table>

            </ion-item>
          </ion-list>

        </!--span-->


        <ion-header *ngIf="page_scan===true">{{ 'devicelistpage.devicesInViscinity' | translate }}</ion-header>

        <ion-list *ngIf="page_scan===true">
          <ion-item *ngFor="let dev of devices">
            <table>
              <tr (click)="toAssistant(dev)">
                <td width="50px">

                  <ion-icon *ngIf="dev.registeredTo===user.id" src="assets/ICONS/add-list.svg"
                            color="success"></ion-icon>
                </td>
                <td width="350px" class="row_1_1">
                  {{ dev.label }}
                </td>

                <td width="100px" class="row_devicerow">
                  <div style="text-align: center;">{{ dev.last }}
                    <ion-icon *ngIf="dev.last!==null && dev.last!==''" name="wifi-outline" color="success"></ion-icon>
                  </div>
                </td>
                <td width="50px">
                  <ion-icon name="chevron-forward-outline"></ion-icon>
                </td>
              </tr>
            </table>

          </ion-item>
        </ion-list>


      </div>
    </div>
  </ion-content>

  <ion-footer [translucent]="true" *ngIf="page_start===true">
    <ion-toolbar>

      <table width="100%">
        <tr>
          <td width="13%">&nbsp;</td>
          <td width="75%">

            <button class="center hootsbutton bluebutton" expand="block" (click)="startIt()">
              <ion-icon name="bluetooth-outline"></ion-icon>
              {{ 'devicelistpage.search' | translate }}
            </button>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>

        <tr>
          <td width="13%">&nbsp;</td>
          <td width="75%">

            <div style="text-align: center;">
              &nbsp;
            </div>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>
      </table>

    </ion-toolbar>
  </ion-footer>

  <ion-footer [translucent]="true" *ngIf="page_scan===true">
    <ion-toolbar>

      <table width="100%">
        <tr>
          <td width="13%">&nbsp;</td>
          <td width="75%">

            <span>
              <ion-icon *ngIf="!runScan" class="center" style="zoom:3" src="assets/ICONS/refresh.svg"
                        (click)="startScan()"> </ion-icon>
              <ion-spinner class="center" style="zoom:1.5" *ngIf="runScan" color="warning"
                           (click)="stopScan()"></ion-spinner>
            </span>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>
        <tr>
          <td width="13%">&nbsp;</td>
          <td width="75%">

            <div style="text-align: center;">
              <span *ngIf="!runScan" class="ion-text-center" (click)="startScan()">Refresh </span>
              <span *ngIf="runScan" class="ion-text-center" (click)="stopScan()">Scan abbrechen </span>
            </div>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>
        <tr>
          <td width="13%">&nbsp;</td>
          <td width="75%">

            <div style="text-align: center;">
              &nbsp;
            </div>
          </td>
          <td>
            &nbsp;
          </td>
        </tr>
      </table>

      <div class="mittig" *ngIf="initial==='1'">
        <ion-icon style="zoom: 0.5" name="radio-button-on-outline"></ion-icon>&nbsp;&nbsp;
        <ion-icon style="zoom: 0.5" name="radio-button-off-outline"></ion-icon>&nbsp;&nbsp;
        <ion-icon style="zoom: 0.5" name="radio-button-off-outline"></ion-icon>&nbsp;&nbsp;
        <ion-icon style="zoom: 0.5" name="radio-button-off-outline"></ion-icon>&nbsp;&nbsp;
        <ion-icon style="zoom: 0.5" name="radio-button-off-outline"></ion-icon>
      </div>
      <br/>


    </ion-toolbar>
  </ion-footer>


</div>
